import * as Sentry from '@sentry/vue'

import { Mode } from '@shared/lib/environment'
import { isSentryEnabled } from '@shared/lib/isSentryEnabled'

const loadSentryIntegrations = async (router: ReturnType<typeof useRouter>) => {
  const { replayIntegration, browserTracingIntegration } =
    await import('@sentry/vue')

  Sentry.addIntegration(
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  )

  Sentry.addIntegration(
    browserTracingIntegration({
      router,
    }),
  )
}

/* Плагин для прокидывания sentry в контекст приложения */
export default defineNuxtPlugin({
  name: 'initSentry',
  async setup({ vueApp }) {
    const { SENTRY_DSN, MODE } = useRuntimeConfig().public

    if (isSentryEnabled(MODE)) {
      const router = useRouter()

      /* В зависимости от прода, выставляем нужное значение */
      const sampleRate = MODE === Mode.PROD ? 0.5 : 0.2

      /* Инициализация Sentry */
      Sentry.init({
        app: vueApp,
        dsn: SENTRY_DSN,
        environment: MODE,

        tracesSampleRate: sampleRate,

        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      })

      /* Lazy-load загрузка sentry плагинов */
      await loadSentryIntegrations(router)
    }

    return {
      provide: {
        sentryCaptureException: Sentry.captureException,
      },
    }
  },
})
